import { render, staticRenderFns } from "./speech.vue?vue&type=template&id=b26a7170&scoped=true&"
import script from "./speech.vue?vue&type=script&lang=js&"
export * from "./speech.vue?vue&type=script&lang=js&"
import style0 from "./speech.vue?vue&type=style&index=0&id=b26a7170&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b26a7170",
  null
  
)

export default component.exports